import { reportApi } from '../http/httpClient'

export enum AuditActionEnum {
  TEAM = 'TEAM',
  TEAM_MEMBER = 'TEAM_MEMBER',
  USER = 'USER',
  TABLE = 'TABLE',
  TRANSACTION = 'TRANSACTION',
  BANNER = 'BANNER',
  CUSTOMER = 'CUSTOMER',
  SEARCH = 'SEARCH',
}

export const actionDic = {
  [AuditActionEnum.TEAM]: 'Equipe',
  [AuditActionEnum.TEAM_MEMBER]: 'Membro da equipe',
  [AuditActionEnum.TABLE]: 'Tabela',
  [AuditActionEnum.SEARCH]: 'Pesquisa',
  [AuditActionEnum.BANNER]: 'Banner',
  [AuditActionEnum.USER]: 'Usuario',
  [AuditActionEnum.TRANSACTION]: 'Transação',
  [AuditActionEnum.CUSTOMER]: 'Cliente',
}

export enum SupportOptionsEnum {
  USER_SET_ROLE = 'ROLE',
  TEAM_SET_LEADER = 'LEADER',
  TEAM_SET_SUPERVISOR = 'SUPERVISOR',
  TEAM_SET_MANAGER = 'MANAGER',
  APPROVE = 'APPROVE',
  REFUSE = 'REFUSE',
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  EDIT = 'EDIT',
  ACCESS = 'ACCESS',

  CUSTOMER = 'CUSTOMER',
  TRANSACTION = 'TRANSACTION',
  USER = 'USER',
}

export const optionsDic = {
  [SupportOptionsEnum.USER_SET_ROLE]: 'Alterar cargo',
  [SupportOptionsEnum.TEAM_SET_LEADER]: 'Mudança lider',
  [SupportOptionsEnum.TEAM_SET_SUPERVISOR]: 'Mudança supervisor',
  [SupportOptionsEnum.TEAM_SET_MANAGER]: 'Mudança gerente',
  [SupportOptionsEnum.APPROVE]: 'Aprovar',
  [SupportOptionsEnum.REFUSE]: 'Reprovar',
  [SupportOptionsEnum.ADD]: 'Adicionar/Criar',
  [SupportOptionsEnum.REMOVE]: 'Remover',
  [SupportOptionsEnum.EDIT]: 'Editar',
  [SupportOptionsEnum.ACCESS]: 'Acesso',

  [SupportOptionsEnum.USER]: 'Vendedor',
  [SupportOptionsEnum.TRANSACTION]: 'Transação',
  [SupportOptionsEnum.CUSTOMER]: 'Cliente',
}

export interface ReportSupports {
  user: {
    _id?: string
    name?: string
  }
  action: AuditActionEnum
  props: {
    values: string[]
    options: SupportOptionsEnum[]
    target: {
      name: string
      cpf?: string
      tableCode?: string
    }
  }
  createdAt: string
}

export interface ReportSupportsResponse {
  items: ReportSupports[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportSupportsParams {
  categories?: string
  supportIds?: string
  startDate?: string
  endDate?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportSupports(
  params?: ReportSupportsParams | undefined,
) {
  const { data } = await reportApi.get<ReportSupportsResponse>(
    '/report/audits',
    {
      params,
    },
  )

  return data
}
